import React, {useState, } from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {Link} from 'gatsby';
import {IoIosSearch, IoIosClose} from 'react-icons/io';
import {DrawerProvider} from '../drawer/drawer-context';
import Menu from './menu';
import MobileMenu from './mobile-menu';
import SearchContainer from '../../containers/search/search';
import {FaMoon, FaSun} from "react-icons/fa";
import styled from "styled-components";
import HeaderWrapper, {
    NavbarWrapper,
    Logo,
    MenuWrapper,
    NavSearchButton,
    NavSearchWrapper,
    SearchCloseButton,
    NavSearchFromWrapper,
} from './navbar.style';

// import LogoImage from '../../../content/assets/logo.png';
import {darkTheme} from "../reset-css";

type NavbarProps = {
    className?: string;
    toggleTheme?: () => void;
};

const Moon = styled(FaMoon)`
  position: absolute;
  cursor: pointer;
  opacity: ${({ theme }) => theme === darkTheme ? '1' : '0'};
  color: #ababab;
`;

const Sun = styled(FaSun)`
  position: absolute;
  transform: scale(1.25);
  cursor: pointer;
  opacity: ${({ theme }) => theme === darkTheme ? '0' : '1'};
  color: #292929;
`;

const ThemeToggle = styled.div`
  left: 0;
  top: 6px;
  margin-left: 40px;
  position: relative;
  height: 31px;
  margin-right: 20px;
  @media (max-width: 990px) {
    margin-left: 20px;
  }
  @media (max-width: 380px) {
    margin-left: 0;
  }
  @media (max-width: 240px) {
    display: none;
  }
`

const MenuItems = [
    {
        label: 'Home',
        url: '/',
    },
    {
        label: 'Academic',
        url: '/academic',
    },
    {
        label: 'About',
        url: '/about',
    },
    {
        label: 'Contact',
        url: '/contact',
    },
];

const Navbar: React.FunctionComponent<NavbarProps> = ({
                                                          className,
                                                          toggleTheme,
                                                          ...props
                                                      }) => {

    const [state, setState] = useState({
        toggle: false,
        search: '',
    });

    const toggleHandle = () => {
        setState({
            ...state,
            toggle: !state.toggle,
        });
    };

    // Add all classs to an array
    const addAllClasses = ['header'];

    // className prop checking
    if (className) {
        addAllClasses.push(className);
    }

    const Data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
    }
  `);
    const {author,} = Data.site.siteMetadata;

    return (
        <HeaderWrapper className={addAllClasses.join(' ')} {...props}>
            <NavbarWrapper className="navbar">
                <DrawerProvider>
                    <MobileMenu items={MenuItems}/>
                </DrawerProvider>
                <Logo>
                    <Link to="/">
                        <h1 className={"transition-join"}>{author}</h1>
                        {/*<img src={LogoImage} alt="logo" />*/}
                    </Link>
                </Logo>
                <MenuWrapper>
                    <Menu items={MenuItems}/>
                </MenuWrapper>
                <NavSearchButton
                    type="button"
                    aria-label="search"
                    onClick={toggleHandle}
                >
                    <IoIosSearch
                        size="23px"
                        className={"transition-join"}
                    />
                </NavSearchButton>
                <ThemeToggle aria-label="theme-toggle" onClick={toggleTheme}>
                    <Moon/><Sun/>
                </ThemeToggle>
            </NavbarWrapper>

            <NavSearchWrapper className={state.toggle === true ? 'expand' : ''}>
                <NavSearchFromWrapper>
                    <SearchContainer/>
                    <SearchCloseButton
                        type="submit"
                        aria-label="close"
                        onClick={toggleHandle}
                    >
                        <IoIosClose/>
                    </SearchCloseButton>
                </NavSearchFromWrapper>
            </NavSearchWrapper>
        </HeaderWrapper>
    );
};

export default Navbar;
